if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.track = this.querySelector('.product-media-modal__content');
        this.thumbnails = this.querySelector('.product-media-modal__thumbnails');

        // Media modals close on any mouse click; keep clicks on the gallery controls inside the viewer
        this.querySelectorAll('.product-media-modal__arrow').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', () => this.goTo(this.currentIndex + Number(button.dataset.direction)));
        });
        this.thumbnails?.addEventListener('pointerup', (event) => event.stopPropagation());

        this.track?.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.updateCurrent());
          },
          { passive: true }
        );

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowRight') this.goTo(this.currentIndex + 1);
          if (event.key === 'ArrowLeft') this.goTo(this.currentIndex - 1);
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      get slides() {
        return Array.from(this.track.children).filter((slide) => getComputedStyle(slide).display !== 'none');
      }

      get currentIndex() {
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        this.renderThumbnails();
        const index = Math.max(this.slides.indexOf(activeMedia), 0);
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: 'instant' });
        this.updateCurrent(index);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      renderThumbnails() {
        const slides = this.slides;
        this.classList.toggle('product-media-modal--single', slides.length < 2);
        if (!this.thumbnails) return;

        this.thumbnails.replaceChildren(
          ...slides.map((slide, index) => {
            const image = slide.tagName === 'IMG' ? slide : slide.querySelector('img');
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'product-media-modal__thumbnail';
            button.setAttribute('aria-label', `${index + 1} / ${slides.length}`);
            if (image) {
              const thumbnail = document.createElement('img');
              thumbnail.src = (image.getAttribute('src') || '').replace(/width=\d+/, 'width=160');
              thumbnail.alt = '';
              thumbnail.loading = 'lazy';
              button.appendChild(thumbnail);
            }
            button.addEventListener('click', () => this.goTo(index));
            return button;
          })
        );
      }

      goTo(index) {
        const count = this.slides.length;
        if (count < 2) return;
        const next = (index + count) % count;
        this.track.scrollTo({ left: next * this.track.clientWidth, behavior: 'smooth' });
      }

      updateCurrent(index = this.currentIndex) {
        const thumbnails = this.thumbnails ? Array.from(this.thumbnails.children) : [];
        thumbnails.forEach((thumbnail, i) => {
          if (i === index) {
            thumbnail.setAttribute('aria-current', 'true');
            const left = thumbnail.offsetLeft - (this.thumbnails.clientWidth - thumbnail.offsetWidth) / 2;
            this.thumbnails.scrollTo({ left, behavior: 'smooth' });
          } else {
            thumbnail.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
